import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { ListTable } from '../../molecules/ListTable';
import { IProduct } from '../../../utils/entities/interface';
import { capitalizeWords } from '../../../utils/helper';
import { getProductTypeLabel } from '../../../utils/constants';

export const ProductList = ({
  products,
  isLoading,
  onManageClick,
  onlyview,
  headerCells,
}: {
  products: IProduct[];
  isLoading: boolean;
  onManageClick?: (id: string) => void;
  onlyview?: boolean;
  headerCells: [string, number][];
}) => {
  const actions = [
    {
      icon: <RemoveRedEyeOutlinedIcon />,
      onClick: (row: IProduct) =>
        window.open(`/productdetails/${row._id}`, '_self'),
    },
  ];

  return (
    <ListTable
      headerCells={headerCells}
      rows={products}
      isLoading={isLoading}
      actions={actions}
      renderCell={(product: IProduct, colIndex: number) => {
        switch (colIndex) {
          case 0:
            return product.name || '-';

          case 1:
            return capitalizeWords(product.brand) || 'N/A';

          case 2:
            return getProductTypeLabel(product.type) || 'N/A';

          case 3:
            return product.tonnage || 'N/A';

          case 4:
            return product.model || 'N/A';

          case 5:
            return product.retailPrice
              ? `£ ${product.retailPrice.toLocaleString()}`
              : 'N/A';

          case 6:
            return product.customerPrice
              ? `£ ${product.customerPrice.toLocaleString()}`
              : 'N/A';

          case 7:
            return product.featured ? 'Yes' : 'No';

          default:
            return null;
        }
      }}
    />
  );
};
